import React,{useState,useEffect,Fragment} from 'react';
import Modal from '../UI/Modal';
import Button from '../UI/Button';
import classes from './OrderChangeHistoryView.module.css';
import { Navigate, Route, Routes, useNavigate,Outlet, Link  } from "react-router-dom";
import {useCookies} from 'react-cookie';
import axios from 'axios';


const OrderChangeHistory = (props) =>{
	const navigate = useNavigate();
	const [cookies, setCookies, removeCookies] = useCookies(['user']);
	const [order, setOrder] = useState('');

	useEffect(()=>{
		const config = {
      		headers: { 'Authorization': 'Bearer '+cookies.Token}
    	};
		axios.post('https://api.orders.e-interior.gr/api/order/'+props.id,{
      		key: cookies.Token},
      		config
    	).then(function (response) {
    		setOrder(response.data);
    		console.log(response.data)
    	}).catch(function (error) {
	      if (error.response.data.message==="Unauthenticated."){
	          removeCookies('Name', { path: '/' });
	          removeCookies('Token', { path: '/' });
	          navigate("/user-login");
	        }
      console.log(error);
    });
	},[])
	return(
		<Modal>
		<button className={classes.close} onClick={props.onClose}>Πίσω</button>
		<h2>Ιστορικό Κατάστασης</h2>
		<table className="table table-hover">
		<thead><tr>
			<th>Ημερομηνία</th>
			<th>Κατάσταση</th>
		</tr></thead>
		{order.status_history && order.status_history.map(result =>{
			let statusText=''
			switch(result.status) {
			    case "not_submitted_yet":
			      statusText="Δημιουργήθηκε";
			      break;
			    case "submitted":
			      statusText="Καταχωρήθηκε";
			      break;
			    case "preparing":
			      statusText="Ετοιμάζεται";
			      break;
			    case "ready":
			      statusText="Όλα έτοιμα";
			      break;
			    case "communicated":
			      statusText="Ειδοποιήθηκε";
			      break;
			    case "completed":
			      statusText="Ολοκληρωμένη";
			      break;
			    case "canceled":
			      statusText="Ακυρωμένη";
			      break;
			    case "ypoloipo":
			    	statusText="Εκκρεμεί υπόλοιπο!"
		    		break;
			    default:
			      statusText=result.status;
			      break;
			  }
			return(
				<tr>
					<td>{new Date(result.created_at).toLocaleString()}</td>
					<td>{statusText}</td>
				</tr>
			)
		})}
		</table>
		</Modal>
	)
}
export default OrderChangeHistory;